module.exports = require('./dist/InfiniteScroll')
